import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import { Provider } from "react-redux";
import store from "./store";
import App from './App';
import { setupInterceptors } from "./services/HttpService";
import { setupInterceptorsLogin } from "./services/HttpServiceAccount";

setupInterceptorsLogin(store); //Register HTTP interceptor to handle API exceptions.
setupInterceptors(store); //Register HTTP interceptor to handle API exceptions.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  //</React.StrictMode>
);
